export const STATUS_USER = [
    { label : 'Activé', value : true },
    { label : 'Désactivé', value : false },
];

export const STATUS_BIEN_DIFFUSED = 'DIFFUSED';
export const STATUS_BIEN_UNDIFFUSED = 'UNDIFFUSED';
export const STATUS_BIEN_ARCHIVE = 'ARCHIVE';